export var PermissionValue;
(function (PermissionValue) {
    PermissionValue["READ_TRANSACTIONS"] = "read:transactions";
    PermissionValue["WRITE_SESSIONS"] = "write:sessions";
    PermissionValue["WRITE_PASSWORD"] = "write:password";
    PermissionValue["READ_PRIVATE_MESSAGES"] = "read:private_messages";
    PermissionValue["WRITE_PRIVATE_MESSAGES"] = "write:private_messages";
})(PermissionValue || (PermissionValue = {}));
//# sourceMappingURL=permission.js.map